import script from "./FollowerListModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FollowerListModal.vue?vue&type=script&setup=true&lang=ts"

import "./FollowerListModal.vue?vue&type=style&index=0&id=0b8f11bf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b8f11bf"]])

export default __exports__